import { useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';

import { Faq } from './components/Faq';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { TrialSignup } from './components/TrialSignup';
import { LeadForm } from './components/LeadForm';
import { LeadSetup } from './components/LeadSetup';
import { LegalPage } from './components/LegalPage';

const PLAN_NAMES: Record<number, string> = {
  1: '無料トライアル',
  2: 'スタンダード',
  3: 'プロフェッショナル',
  4: 'エンタープライズ',
};

export function App() {
  const [trialOpen, setTrialOpen] = useState(false);
  const [leadOpen, setLeadOpen] = useState(false);
  const [leadPlanId, setLeadPlanId] = useState<number | null>(null);

  if (location.pathname.startsWith('/setup')) return <LeadSetup />;
  if (location.pathname === '/terms') return <LegalPage pageId="terms" />;
  if (location.pathname === '/privacy') return <LegalPage pageId="privacy" />;
  if (location.pathname === '/tokushoho') return <LegalPage pageId="tokushoho" />;

  const handleTrialClick = () => setTrialOpen(true);
  const handleLeadClick = (planId: number) => {
    setLeadPlanId(planId);
    setLeadOpen(true);
  };

  return (
    <>
      <Header onTrialClick={handleTrialClick} />
      <main>
        <Hero onTrialClick={handleTrialClick} onPricingClick={() => document.getElementById('pricing')?.scrollIntoView({ behavior: 'smooth' })} />
        <Features />
        <Pricing onTrialClick={handleTrialClick} onLeadClick={handleLeadClick} />

        <Faq />
        <Contact />
      </main>
      <Footer />
      <TrialSignup open={trialOpen} onClose={() => setTrialOpen(false)} />
      <LeadForm
        open={leadOpen}
        onClose={() => { setLeadOpen(false); setLeadPlanId(null); }}
        planId={leadPlanId}
        planName={leadPlanId ? (PLAN_NAMES[leadPlanId] ?? `プラン${leadPlanId}`) : ''}
      />
    </>
  );
}
